import { Loader } from '@firmable/icons';
import { reportError } from '@firmable/telemetry/core';
import { Suspense } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { ErrorBoundaryFallback } from '../ErrorBoundaryFallback';

interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ReactElement;
}

function ErrorBoundary({ children, fallback = <ErrorBoundaryFallback.Message />, ...rest }: ErrorBoundaryProps) {
  return (
    <ReactErrorBoundary
      fallback={fallback}
      onError={(error, errorInfo) => {
        // Routed through the shared reporter rather than logfire directly, so
        // this package stays SDK-free for the apps that have not opted in yet
        // (admin, hubspot, mobile). Its default is the console.error this
        // replaced, so nothing regresses for them.
        reportError('React ErrorBoundary caught an error', error, {
          'error.source': 'react-error-boundary',
          'react.component_stack': errorInfo?.componentStack?.slice(0, 2000),
        });
      }}
      {...rest}>
      <Suspense
        fallback={
          <div className="flex items-center justify-center w-full h-full">
            <Loader.Grid />
          </div>
        }>
        {children}
      </Suspense>
    </ReactErrorBoundary>
  );
}

export { ErrorBoundary };
